var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3095_246351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5833 0.367432H3.01244C2.42509 0.367432 1.8618 0.600754 1.44649 1.01607C1.03117 1.43138 0.797852 1.99467 0.797852 2.58202V28.1528C0.797852 28.7402 1.03117 29.3035 1.44649 29.7188C1.8618 30.1341 2.42509 30.3674 3.01244 30.3674H28.5833C29.1706 30.3674 29.7339 30.1341 30.1492 29.7188C30.5645 29.3035 30.7979 28.7402 30.7979 28.1528V2.58202C30.7979 1.99467 30.5645 1.43138 30.1492 1.01607C29.7339 0.600754 29.1706 0.367432 28.5833 0.367432ZM9.73952 25.9237H5.2291V11.5966H9.73952V25.9237ZM7.48119 9.61118C6.96956 9.6083 6.47025 9.45393 6.04627 9.16754C5.62229 8.88116 5.29265 8.4756 5.09895 8.00204C4.90525 7.52849 4.85616 7.00817 4.95789 6.50675C5.05962 6.00533 5.3076 5.54528 5.67055 5.18466C6.03349 4.82404 6.49512 4.57902 6.99719 4.48051C7.49925 4.382 8.01924 4.43442 8.49154 4.63116C8.96384 4.8279 9.36728 5.16014 9.65093 5.58595C9.93459 6.01175 10.0858 6.51205 10.0854 7.02368C10.0902 7.36622 10.026 7.70623 9.89662 8.02344C9.76724 8.34064 9.57533 8.62856 9.33232 8.87002C9.0893 9.11147 8.80016 9.30154 8.48213 9.42887C8.1641 9.55621 7.82369 9.61821 7.48119 9.61118ZM26.3645 25.9362H21.8562V18.1091C21.8562 15.8008 20.8749 15.0883 19.6083 15.0883C18.2708 15.0883 16.9583 16.0966 16.9583 18.1674V25.9362H12.4479V11.607H16.7854V13.5924H16.8437C17.2791 12.7112 18.8041 11.2049 21.1312 11.2049C23.6479 11.2049 26.3666 12.6987 26.3666 17.0737L26.3645 25.9362Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3095_246351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.797852 0.367432)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinicon);
export default __webpack_public_path__ + "static/media/linkedin.icon.4e73747a1acbb1b59c90a02e97c604f1.svg";
export { ForwardRef as ReactComponent };